import { Box, SxProps, Typography } from '@mui/material'

import { PendingSummary } from 'hooks/api/instructionSummary'

interface SummaryContentProps {
  item: PendingSummary
}

/**
 * サマリ内容表示コンポーネント
 */
export function SummaryContent({ item }: SummaryContentProps) {
  return (
    <>
      <Box sx={sectionStyle}>
        <Typography variant="subtitle2" color="primary" gutterBottom>
          直近の状況
        </Typography>
        <Typography variant="body2" sx={contentStyle}>
          {item.summary.recentSituation || '(未入力)'}
        </Typography>
      </Box>

      <Box sx={sectionStyle}>
        <Typography variant="subtitle2" color="primary" gutterBottom>
          次回確認すること
        </Typography>
        <Typography variant="body2" sx={contentStyle}>
          {item.summary.nextCheckPoints || '(未入力)'}
        </Typography>
      </Box>

      <Box sx={sectionStyle}>
        <Typography variant="subtitle2" color="primary" gutterBottom>
          長期傾向
        </Typography>
        <Typography variant="body2" sx={contentStyle}>
          {item.summary.longTermTrend || '(未入力)'}
        </Typography>
      </Box>
    </>
  )
}

const sectionStyle: SxProps = {
  mb: 2,
}

const contentStyle: SxProps = {
  whiteSpace: 'pre-wrap',
  backgroundColor: 'grey.50',
  p: 1.5,
  borderRadius: 1,
}
